module.exports = __webpack_public_path__ + "static/img/01.627a413.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/01.png
// module id = P2mS
// module chunks = 1